/** @format */
import React, { useEffect, useState } from 'react';
import CardHeader from '../../../components/Heading/CardHeaderExt';
import Card from '../../../components/Card/Card';
import CardBody from '../../../components/Card/CardBody';
import MoneyOffIcon from '@material-ui/icons/MoneyOff';
import Filter from '../../../interfaces/forms/Filter';
import Order from '../../../interfaces/forms/Order';
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';
import GeneralDialog from '../../../components/Dialog/GeneralDialog';
import { Moment } from 'moment';
import DiscountRateForm from '../Components/DiscountRateForm';
import RateDiscountTable from '../Components/RateDiscountTable';
import { useParams } from 'react-router-dom';
import { ItemLoaders } from '../../../core/loaders/ItemLoaders';
import { FormGeneralHelper } from '../../../helpers/FormGeneral';
import { configDefault } from '../../../core/config';
import { DiscountHelper } from '../../../helpers/DiscountHelper';
import { NotificationHelper } from '../../../helpers/NotificationHelper';
import i18n from '../../../core/i18n';
import { makeStyles } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import adescomStyle from '../../../assets/jss/adescom/adescomStyle';
import { DateHelperTs } from '../../../helpers/DateHelperTs';
import { DiscountCollectionInterface } from '../../../interfaces/api/DiscountCollectionInterface';
import { DISCOUNT_CONSTANTS } from '../../../modules/discounts/reducers';
import { DiscountInterface } from '../../../interfaces/billing/DiscountInterface';
import { FilterReducerFieldName } from '../../../modules/filter/FilterReducers';
import { FilterListReducerFieldName } from '../../../modules/filter/FilterListReducers';
import RateSchemaInterface from '../../../interfaces/billing/RateSchemaInterface';
import { CurrencyHelper } from '../../../helpers/CurrencyHelper';
import AlertConfirm from '../../../components/Info/AlertConfirm';
import { PriceThresholdEntityInterface } from '../../Pricelists/Components/PriceThresholds/PriceThresholdContainer';

interface PlatformResellerRateDiscountInterface {
    platformResellerId?: string | number | null;
}

export interface DiscountRateEntity {
    name: string | null;
    active: boolean;
    dateStart: Moment | string | null;
    dateEnd: Moment | string | null;
    type: number;
    filterType: number;
    currency: number;
    autoShare: boolean;
    layout: number;
    platformResellerId: number;
    onlyThisPromo: boolean;
    skipInitialPrice: boolean;
    historyLength: string;
    oneTime: boolean;
    firstMonthOnly: boolean;
    propOnFirstMonth: boolean | null;
    count: number | null;
    gracePeriod: Moment | string | null;
    destination: string | null;
    payment: boolean;
    rateParam: string | null;
    params: string | null;
    allowUseOnProduct: number;
    customPrefix: string | null;
    useAllResellerNumbers: boolean;
    priority: number;
}

const RateSchemaInitialState: RateSchemaInterface = {
    hourRange: 24,
    countingUnit: 1,
    price1: '0.0000000000',
    initial: '0.0000000000',
    interval1: 1,
    interval2: 1,
    price2: '0.0000000000',
    duration1: 1,
    type: 0,
    days: -2,
    useRatio: false,
    byDiscount: false,
    subtype: null,
};

const PlatformResellerRateDiscount = (props: PlatformResellerRateDiscountInterface): React.ReactElement => {
    const useStyle = makeStyles(adescomStyle);
    const classes = useStyle();
    const dispatch = useDispatch();
    const { id } = useParams();

    const URI = '/discounts';

    const [filters, setFilters] = useState<Array<Filter>>([]);
    const [orders, setOrders] = useState<Array<Order>>([]);
    const useReducer = false;
    const [discounts, setDiscounts] = useState<DiscountCollectionInterface | null>(null);
    const [activeDiscount, setActiveDiscount] = useState<DiscountInterface | null>(null);
    const idAsNumber = parseInt(id.split('/')[id.split('/').length - 1]);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState<boolean>(false);
    const [rateEntity, setRateEntity] = useState<RateSchemaInterface>(RateSchemaInitialState);
    const [priceThresholds, setPriceThresholds] = useState<Array<PriceThresholdEntityInterface>>([]);
    const [afterInitLoad, setAfterInitLoad] = useState<boolean>(false);

    const [rateEntityStatus, setRateEntityStatus] = useState<any>({
        hourRange: null,
        countingUnit: null,
        price1: null,
        initial: null,
        interval1: null,
        interval2: null,
        price2: null,
        duration1: null,
        type: null,
        days: null,
        useRatio: null,
        byDiscount: null,
    });

    const changeRateInput = (e: any, stateName: string): void => {
        if (!stateName || stateName === undefined) {
            stateName = e.target.name;
        }
        setRateEntity({
            ...rateEntity,
            [stateName]: e.target.value,
        });
    };
    const changeRateSelect = (e: any, stateName: string): void => {
        setRateEntity({
            ...rateEntity,
            [stateName]: e.target.value,
        });
    };

    const initialRateEntity = {
        name: null,
        active: false,
        dateStart: DateHelperTs.getCurrentDateTime(),
        dateEnd: null,
        type: 4,
        filterType: 2,
        currency: 0,
        autoShare: false,
        layout: 0,
        platformResellerId: parseInt(id.split('/')[id.split('/').length - 1]),
        onlyThisPromo: false,
        skipInitialPrice: false,
        historyLength: '0',
        oneTime: false,
        firstMonthOnly: false,
        propOnFirstMonth: null,
        count: null,
        payment: false,
        gracePeriod: null,
        destination: null,
        rateParam: null,
        params: null,
        allowUseOnProduct: -1,
        customPrefix: null,
        useAllResellerNumbers: false,
        priority: 1,
    };

    const [discountAddFormOpen, setDiscountAddFormOpen] = useState<boolean>(false);
    const [entity, setEntity] = useState<DiscountRateEntity>(initialRateEntity);

    const [entityStatus, setEntityStatus] = useState<any>({
        name: null,
        active: null,
        dateStart: null,
        dateEnd: null,
        type: null,
        filterType: null,
        currency: null,
        autoShare: null,
        layout: null,
    });

    const updateOrders = (orders: Array<Order>): void => {
        setOrders(orders);
    };
    const updateFilters = (filters: Array<Filter>): void => {
        setFilters(filters);
    };

    const openAddDiscountModal = (): void => {
        setActiveDiscount(null);
        setEntity(initialRateEntity);
        setRateEntity(RateSchemaInitialState);
        setDiscountAddFormOpen(true);
    };

    const closeAddDiscountModal = (): void => {
        setActiveDiscount(null);
        setEntity(initialRateEntity);
        setRateEntity(RateSchemaInitialState);
        setDiscountAddFormOpen(false);
        setPriceThresholds([]);
    };

    const saveDiscount = (): void => {
        const errors = DiscountHelper.validateDiscountRateEntityBeforePersist(entity);
        if (errors.length > 0) {
            errors.map((el: { key: string; value: string }) => {
                NotificationHelper.notifyError(el.value, dispatch);
            });

            return;
        }
        let modifiedRateEntity = { ...rateEntity };
        modifiedRateEntity = beautifyCurrency(modifiedRateEntity);
        modifiedRateEntity = fixComma(modifiedRateEntity);
        let modifiedEntity = { ...entity };
        modifiedRateEntity = fixType(modifiedEntity, modifiedRateEntity);
        modifiedEntity.rateParam = JSON.stringify(modifiedRateEntity);
        const itemLoaders = new ItemLoaders(dispatch);

        if (priceThresholds.length > 0) {
            const params = {
                [DiscountHelper.PARAM_PROPERTY.PRICE_THRESHOLD]: priceThresholds,
            };

            modifiedEntity.params = JSON.stringify(params);
        }

        if (activeDiscount) {
            setConfirmDialogOpen(false);
        }

        if (activeDiscount) {
            itemLoaders.putWithCallback(
                FormGeneralHelper.getByUri(FormGeneralHelper.getPath(`${URI}/${activeDiscount.id}`, configDefault.PLATFORM_API_PREFIX)),
                DISCOUNT_CONSTANTS.EDIT,
                DiscountHelper.prepareFinalDiscountWithParams(modifiedEntity),
                {
                    onSuccess: (data: DiscountInterface) => {
                        cancelActivation();
                        if (idAsNumber) {
                            itemLoaders.getListWithCallback(
                                FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/discounts')),
                                DISCOUNT_CONSTANTS.LIST,
                                [
                                    { name: 'rateDiscount', value: true },
                                    {
                                        name: 'platformResellerId',
                                        value: parseInt(id.split('/')[id.split('/').length - 1]),
                                    },
                                ],
                                [],
                                (data: DiscountCollectionInterface | null) => {
                                    if (!useReducer) {
                                        setDiscounts(data);
                                        setAfterInitLoad(false);
                                    }
                                },
                                { propagateDataToCallback: !useReducer, dispatchAfterCallback: useReducer }
                            );
                        }

                        NotificationHelper.notifySuccess('discount:n.success_edit', dispatch);
                    },
                    onError: (error: any) => {
                        NotificationHelper.notifyError(i18n.t(error.message.message), dispatch);
                    },
                },
                {
                    propagateDataToCallback: true,
                    dispatchAfterCallback: true,
                }
            );
        } else {
            itemLoaders.postWithCallback(
                FormGeneralHelper.getByUri(FormGeneralHelper.getPath(URI, configDefault.PLATFORM_API_PREFIX)),
                DISCOUNT_CONSTANTS.ADD,
                DiscountHelper.prepareFinalDiscountWithParams(modifiedEntity),
                {
                    onSuccess: (data: DiscountInterface) => {
                        cancelActivation();
                        itemLoaders.getListWithCallback(
                            FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/discounts')),
                            DISCOUNT_CONSTANTS.LIST,
                            [
                                { name: 'rateDiscount', value: true },
                                { name: 'platformResellerId', value: parseInt(id.split('/')[id.split('/').length - 1]) },
                            ],
                            [],
                            (data: DiscountCollectionInterface | null) => {
                                if (!useReducer) {
                                    setDiscounts(data);
                                    setAfterInitLoad(false);
                                }
                            },
                            { propagateDataToCallback: !useReducer, dispatchAfterCallback: useReducer }
                        );
                        NotificationHelper.notifySuccess('discount:n.success_add', dispatch);
                    },
                    onError: (error: any) => {
                        NotificationHelper.notifyError(i18n.t(error.message.message), dispatch);
                    },
                },
                {
                    propagateDataToCallback: true,
                    dispatchAfterCallback: true,
                }
            );
        }
    };

    const search = (): void => {
        const itemLoader = new ItemLoaders(dispatch);
        itemLoader.getListWithCallback(
            FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/discounts')),
            DISCOUNT_CONSTANTS.LIST,
            [
                ...filters,
                { name: 'rateDiscount', value: true },
                { name: 'platformResellerId', value: parseInt(id.split('/')[id.split('/').length - 1]) },
            ],
            orders,
            (data: DiscountCollectionInterface | null) => {
                if (!useReducer) {
                    setDiscounts(data);
                }
            },
            { propagateDataToCallback: !useReducer, dispatchAfterCallback: useReducer }
        );
    };
    const clearFilters = (): void => {
        setFilters([]);
        setOrders([]);
        dispatch({
            type: FilterReducerFieldName.HEADER_FILTER_MANAGE,
            clearAll: true,
        });
        dispatch({
            type: FilterListReducerFieldName.HEADER_FILTER_MANAGE,
        });
    };

    const editDiscount = (el: DiscountInterface): void => {
        let ent = DiscountHelper.setEntityValueFromDB(el, idAsNumber);
        setActiveDiscount(el);
        setAfterInitLoad(false);
        setEntity(ent);
        setDiscountAddFormOpen(true);
        ent.rateParam = beautifyCurrency(ent.rateParam);
        ent.rateParam = fixComma(ent.rateParam);
        setRateEntity(ent.rateParam);
    };
    const activateDiscount = (el: DiscountInterface): void => {
        setActiveDiscount(el);
        setAfterInitLoad(false);
        setEntity({ ...DiscountHelper.setEntityValueFromDB(el, idAsNumber), active: true });
        setConfirmDialogOpen(true);
    };

    const cancelActivation = (): void => {
        setAfterInitLoad(false);
        setActiveDiscount(null);
        setEntity(initialRateEntity);
        setConfirmDialogOpen(false);
        setDiscountAddFormOpen(false);
    };

    // TODO: find better solution for this
    const beautifyCurrency = (rate: RateSchemaInterface): RateSchemaInterface => {
        if (rate.price1) {
            rate.price1 = CurrencyHelper.numericToStandardPln(rate.price1, 10, true, '.');
        }
        if (rate.price2) {
            rate.price2 = CurrencyHelper.numericToStandardPln(rate.price2, 10, true, '.');
        }
        if (rate.initial) {
            rate.initial = CurrencyHelper.numericToStandardPln(rate.initial, 10, true, '.');
        }

        return rate;
    };

    const fixComma = (rate: RateSchemaInterface): RateSchemaInterface => {
        let fixedRate = rate;
        if (rate.price1) {
            const value = rate.price1.replace(/,/g, '.');
            fixedRate.price1 = value;
        }
        if (rate.price2) {
            const value = rate.price2.replace(/,/g, '.');
            fixedRate.price2 = value;
        }
        if (rate.initial) {
            const value = rate.initial.replace(/,/g, '.');
            fixedRate.initial = value;
        }

        return fixedRate;
    };

    const fixType = (entity: DiscountRateEntity, rateParam: RateSchemaInterface): RateSchemaInterface => {
        let fixedRate = rateParam;

        if (entity.type === DiscountHelper.COST_TYPE.SERVICE) {
            fixedRate.type = 3;
        }

        return fixedRate;
    };

    // useEffect(() => {
    //     console.log(rateEntity);
    // }, [rateEntity]);

    const paginationCallback = (uri?: string): void => {
        if (!id || !uri) {
            return;
        }
        const itemLoader = new ItemLoaders(dispatch);
        itemLoader.getListWithCallback(
            FormGeneralHelper.getByUri(uri),
            DISCOUNT_CONSTANTS.LIST,
            [
                { name: 'rateDiscount', value: true },
                { name: 'platformResellerId', value: parseInt(id.split('/')[id.split('/').length - 1]) },
            ],
            [],
            (data: DiscountCollectionInterface | null) => {
                if (!useReducer) {
                    setDiscounts(data);
                }
            },
            { propagateDataToCallback: !useReducer, dispatchAfterCallback: useReducer }
        );
    };

    useEffect(() => {
        if (!id) {
            return;
        }
        const itemLoader = new ItemLoaders(dispatch);
        itemLoader.getListWithCallback(
            FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/discounts')),
            DISCOUNT_CONSTANTS.LIST,
            [
                { name: 'rateDiscount', value: true },
                { name: 'platformResellerId', value: parseInt(id.split('/')[id.split('/').length - 1]) },
            ],
            [],
            (data: DiscountCollectionInterface | null) => {
                if (!useReducer) {
                    setDiscounts(data);
                }
            },
            { propagateDataToCallback: !useReducer, dispatchAfterCallback: useReducer }
        );
    }, [dispatch, useReducer, id]);

    return (
        <Card>
            <CardHeader icon={<MoneyOffIcon />} trans={'discount:h.rate_discount'} />
            <CardBody>
                <RateDiscountTable
                    openAddDiscountModal={openAddDiscountModal}
                    discounts={discounts}
                    filters={filters}
                    orders={orders}
                    updateOrders={updateOrders}
                    updateFilters={updateFilters}
                    search={search}
                    clearFilters={clearFilters}
                    editDiscount={editDiscount}
                    activateDiscount={activateDiscount}
                    paginationCallback={paginationCallback}
                />
                <GeneralDialog
                    dialogType={'action'}
                    agreeCallback={saveDiscount}
                    agreeCallbackTextLabel={'general:common.save'}
                    disagreeCallbackTextLabel={'general:common:cancel'}
                    disagreeCallback={closeAddDiscountModal}
                    open={discountAddFormOpen}
                    maxWidth={'lg'}
                    title={'discount:h.add_discount_form'}
                >
                    <GridContainer>
                        <GridItem xs={12}>
                            <DiscountRateForm
                                activeDiscount={activeDiscount}
                                entity={entity}
                                setEntity={setEntity}
                                entityStatus={entityStatus}
                                setEntityStatus={setEntityStatus}
                                rateEntity={rateEntity}
                                setRateEntity={setRateEntity}
                                rateEntityStatus={rateEntityStatus}
                                changeRateInput={changeRateInput}
                                changeRateSelect={changeRateSelect}
                                isOpen={discountAddFormOpen}
                                setPriceThresholds={setPriceThresholds}
                                priceThresholds={priceThresholds}
                                afterInitLoad={afterInitLoad}
                                setAfterInitLoad={setAfterInitLoad}
                            />
                        </GridItem>
                    </GridContainer>
                </GeneralDialog>
            </CardBody>
            {confirmDialogOpen && (
                <AlertConfirm
                    content={'discount:h.confirm_activation'}
                    confirmBtnText={'general:common.confirm'}
                    cancelBtnText={'general:common.cancel'}
                    onConfirm={saveDiscount}
                    onCancel={cancelActivation}
                />
            )}
        </Card>
    );
};

export default PlatformResellerRateDiscount;
